import { CUSTOM_CONTRACT_ACTIONS, SetSelectedFileAction } from './types';

export const setSelectedFile = (file: File | null): SetSelectedFileAction => ({
  type: CUSTOM_CONTRACT_ACTIONS.SET_SELECTED_FILE,
  payload: file,
});

export const setNumPages = (pages: number | null) => ({
  type: CUSTOM_CONTRACT_ACTIONS.SET_NUM_PAGES,
  payload: pages,
});

export const setCurrentPage = (page: number) => ({
  type: CUSTOM_CONTRACT_ACTIONS.SET_CURRENT_PAGE,
  payload: page,
});

export const setIsEditingPage = (isEditing: boolean) => ({
  type: CUSTOM_CONTRACT_ACTIONS.SET_IS_EDITING_PAGE,
  payload: isEditing,
});

export const setPageInputValue = (value: string) => ({
  type: CUSTOM_CONTRACT_ACTIONS.SET_PAGE_INPUT_VALUE,
  payload: value,
});

export const setTemplateName = (name: string) => ({
  type: CUSTOM_CONTRACT_ACTIONS.SET_TEMPLATE_NAME,
  payload: name,
});

export const setTemplateFields = (fields: any[]) => ({
  type: CUSTOM_CONTRACT_ACTIONS.SET_TEMPLATE_FIELDS,
  payload: fields,
});

export const setFontSettings = (settings: { fontFamily: string; fontSize: string }) => ({
  type: CUSTOM_CONTRACT_ACTIONS.SET_FONT_SETTINGS,
  payload: settings,
});
